import GetLoading from "../../../share/getLoading";
 import React, { useEffect, useRef, useState } from "react";
import debounce from "lodash.debounce";
import {
  PlusCircleOutlined,
  EditFilled,
  CloseOutlined,
  SearchOutlined,
  SwapOutlined,
  UserOutlined,
  InfoCircleOutlined,
  EnvironmentOutlined,
  BankOutlined,
  ApartmentOutlined,
  IdcardOutlined,
  CalendarOutlined,
  FileTextOutlined, 
  CheckCircleOutlined,    // បន្ថែម
  ExclamationCircleOutlined, // បន្ថែម
} from "@ant-design/icons";
import {
  Table,
  Button,
  Space,
  Tag,
  Popconfirm,
  message,
  Input,
  Select,
  Modal,
  Form,
  DatePicker,
  Avatar,
  Spin,
  
} from "antd";
import { request } from "../../../share/request";
import { boxHeader, boxHeaderTagText } from "../../../styles/boxShadow";

import { getCurrentUser } from "../../../share/getProfile";
import { formateDateSystem, linkPath } from "../../../share/helper";
import dayjs from "dayjs";

const { Option } = Select;

const EmpHistoryMovement = () => {
  const getProfile = getCurrentUser();
  const [loadingSpin, setLoadingSpin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [filterParam, setFilterParam] = useState({
    search: "",
    status: "all",
  });
  const [txtSearch, setTxtSearch] = useState("");

  // Modal states
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [positions, setPositions] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [loadingProvinces, setLoadingProvinces] = useState(false);
  const [loadingOrganizations, setLoadingOrganizations] = useState(false);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [loadingPositions, setLoadingPositions] = useState(false);
  const [loadingStaff, setLoadingStaff] = useState(false);
  const [loadingModalOpen, setLoadingModalOpen] = useState(false);
  const [form] = Form.useForm();

  // Selected values for cascading
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [selectedOrg, setSelectedOrg] = useState(null);
// បន្ថែម state សម្រាប់ approval modal
const [isApproveModalVisible, setIsApproveModalVisible] = useState(false);
const [approveItem, setApproveItem] = useState(null);
const [approveWord, setApproveWord] = useState("");
const [approveForm] = Form.useForm();
  // Staff search filter
  const [objFilterStaff, setObjFilterStaff] = useState({
    search: "",
    org_code: getProfile.org_code,
  });

  // Helper: get image URL
  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath;
    }
    if (imagePath.startsWith('/')) {
      return linkPath + imagePath;
    }
    if (linkPath.endsWith('/')) {
      return linkPath + imagePath;
    } else {
      return linkPath + '/' + imagePath;
    }
  };

  // Helper: extract array from API response
  const extractArrayFromResponse = (res) => {
    if (!res) return [];
    if (Array.isArray(res)) return res;
    if (res.success && Array.isArray(res.data)) return res.data;
    if (res.data && Array.isArray(res.data)) return res.data;
    if (res.list && Array.isArray(res.list)) return res.list;
    if (res.listdepartment && Array.isArray(res.listdepartment)) return res.listdepartment;
    if (res.api_server_list_joiner && Array.isArray(res.api_server_list_joiner)) return res.api_server_list_joiner;
    return [];
  };

  // ==================== GET LIST ====================
  // ក្នុង EmpHistoryMovement.js - getList function
 const getList = async () => {
  setLoading(true);
  
  const currentOrgCode = getProfile.org_code;
  console.log("getList - org_code:", currentOrgCode);
  
  const param = new URLSearchParams({
    search: filterParam.search,
    status: filterParam.status === "all" ? "" : filterParam.status,
  });
  
  // ផ្ញើ org_code តែពេលមានតម្លៃ
  if (currentOrgCode) {
    param.append("org_code", currentOrgCode);
  }
  
  try {
    const res = await request("employee/history?" + param.toString(), "get", {});
    console.log("API Response:", res);
    const dataList = extractArrayFromResponse(res);
    console.log("Data List:", dataList);
    setList(dataList);
  } catch (error) {
    console.log("Error fetching movement history:", error);
    message.error("មិនអាចទាញយកទិន្នន័យបានទេ");
    setList([]);
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
    getList();
  }, [filterParam]);

  // ==================== LOAD PROVINCES ====================
  const loadProvinces = async () => {
    setLoadingProvinces(true);
    try {
      const res = await request("employee/province", "get", {});
      setProvinces(extractArrayFromResponse(res));
    } catch (error) {
      console.log("Error loading provinces:", error);
      setProvinces([]);
    } finally {
      setLoadingProvinces(false);
    }
  };

  // ==================== LOAD ORGANIZATIONS BY PROVINCE ====================
  const loadOrganizations = async (provinceId) => {
    if (!provinceId) {
      setOrganizations([]);
      return;
    }
    setLoadingOrganizations(true);
    try {
      const res = await request(`employee/province/${provinceId}`, "get", {});
      setOrganizations(extractArrayFromResponse(res));
    } catch (error) {
      console.log("Error loading organizations:", error);
      setOrganizations([]);
    } finally {
      setLoadingOrganizations(false);
    }
  };

  // ==================== LOAD DEPARTMENTS BY ORG CODE ====================
  const loadDepartments = async (orgCode) => {
    if (!orgCode) {
      setDepartments([]);
      return;
    }
    setLoadingDepartments(true);
    try {
      const res = await request(`employee/orgdepartment/${orgCode}`, "get", {});
      setDepartments(extractArrayFromResponse(res));
    } catch (error) {
      console.log("Error loading departments:", error);
      setDepartments([]);
    } finally {
      setLoadingDepartments(false);
    }
  };

  // ==================== LOAD POSITIONS BY DEPARTMENT CODE ====================
  const loadPositions = async (departmentCode) => {
    if (!departmentCode) {
      setPositions([]);
      return;
    }
    setLoadingPositions(true);
    try {
      const res = await request(`employee/orgposition/${departmentCode}`, "get", {});
      setPositions(extractArrayFromResponse(res));
    } catch (error) {
      console.log("Error loading positions:", error);
      setPositions([]);
    } finally {
      setLoadingPositions(false);
    }
  };

  // ==================== LOAD STAFF ====================
  const loadStaff = async (filter = {}) => {
    setLoadingStaff(true);
    try {
      const param = new URLSearchParams({
        search: filter.search || "",
        org_code: filter.org_code || getProfile.org_code,
      });

      if (filter.dept_code) {
        param.append("dept_code", filter.dept_code);
      }

      const res = await request(`lettersjoiner?${param.toString()}`, "get", {});
      console.log("Staff list response:", res);

      if (res && res.api_server_list_joiner && Array.isArray(res.api_server_list_joiner)) {
        const staffData = res.api_server_list_joiner.map(staff => ({
          user_id: staff.id,
          username: staff.staff_id_number,
          name: staff.staffname_kh1,
          fullname: staff.staffname_kh1,
          position: staff.position_kh,
          org_code: staff.org_code,
          image: staff.image || null,
          image_url: staff.image ? getImageUrl(staff.image) : null,
          label: `${staff.staffname_kh1} | ${staff.position_kh}`,
        }));
        setStaffList(staffData);
        return staffData;
      }
      return [];
    } catch (error) {
      console.log("Error loading staff:", error);
      message.error("មិនអាចទាញយកបញ្ជីបុគ្គលិកបានទេ");
      return [];
    } finally {
      setLoadingStaff(false);
    }
  };

  // ==================== LOAD STAFF BY ID (for edit) ====================
  const loadStaffById = async (userId) => {
    try {
      const param = new URLSearchParams({
        search: "",
        org_code: getProfile.org_code,
      });
      const res = await request(`lettersjoiner?${param.toString()}`, "get", {});
      
      if (res && res.api_server_list_joiner && Array.isArray(res.api_server_list_joiner)) {
        const staff = res.api_server_list_joiner.find(s => s.id === userId);
        if (staff) {
          return {
            user_id: staff.id,
            username: staff.staff_id_number,
            name: staff.staffname_kh1,
            fullname: staff.staffname_kh1,
            position: staff.position_kh,
            org_code: staff.org_code,
            image: staff.image || null,
            label: `${staff.staffname_kh1} | ${staff.position_kh}`,
          };
        }
      }
      return null;
    } catch (error) {
      console.log("Error loading staff by ID:", error);
      return null;
    }
  };

  // Debounced staff search
  const handleStaffSearch = useRef(
    debounce((inputValue, currentFilter) => {
      loadStaff({ ...currentFilter, search: inputValue });
    }, 300)
  ).current;

  // ==================== DELETE ====================
  const handleDelete = async (item) => {
    setLoadingSpin(true);
    try {
      const res = await request("employee/history", "DELETE", { id: item.id });
      if (res && res.success) {
        message.success("លុបបានជោគជ័យ");
        getList();
      } else {
        message.error(res?.message || "លុបមិនបានសម្រេច");
      }
    } catch (error) {
      console.error("Error while deleting:", error);
      message.error("មានបញ្ហាក្នុងការលុប");
    } finally {
      setLoadingSpin(false);
    }
  };

  // ==================== SEARCH & FILTER ====================
  const handleSearch = (value) => {
    setTxtSearch(value);
    setFilterParam(prev => ({ ...prev, search: value }));
  };

  const handleStatusFilter = (status) => {
    setFilterParam(prev => ({ ...prev, status }));
  };

 // ==================== ADD NEW (WITH LOADING) ====================
const handleAddNew = async () => {
  setEditingId(null);
  form.resetFields();
  form.setFieldsValue({
    transfer_type: 'internal',
    effective_date: dayjs(),
  });
  setLoadingModalOpen(true); // ចាប់ផ្តើម loading modal
  setSelectedProvince(null);
  setSelectedOrg(null);
  setOrganizations([]);
  setDepartments([]);
  setPositions([]);
  setStaffList([]);

  try {
    // Load data ស្របគ្នា
    await Promise.all([
      loadProvinces(),
      loadStaff()
    ]);
    setIsModalVisible(true);
  } catch (error) {
    console.log("Error opening add modal:", error);
    message.error("មិនអាចបើកទម្រង់បានទេ");
  } finally {
    setLoadingModalOpen(false); // បញ្ចប់ loading modal
  }
};

// ==================== EDIT (WITH LOADING) ====================
const handleEdit = async (item) => {
  console.log("Editing item:", item);
  setEditingId(item.id);
  setLoadingModalOpen(true); // ចាប់ផ្តើម loading modal
  setSelectedProvince(null);
  setSelectedOrg(null);
  setOrganizations([]);
  setDepartments([]);
  setPositions([]);

  try {
    // 1. Load provinces and staff in parallel
    await Promise.all([
      loadProvinces(),
      loadStaff()
    ]);

    // 2. Load staff by ID for display
    const staffInfo = await loadStaffById(item.user_id);
    
    // 3. Set staff in form with display value
    if (staffInfo) {
      setStaffList(prev => {
        const exists = prev.find(s => s.user_id === staffInfo.user_id);
        if (!exists) {
          return [...prev, staffInfo];
        }
        return prev;
      });
    }

    // 4. Find province from to_org_code
    let foundProvinceId = null;
    if (item.to_org_code) {
      try {
        const provinceRes = await request(`employee/province/org/${item.to_org_code}`, "get", {});
        if (provinceRes && provinceRes.success && provinceRes.data) {
          foundProvinceId = provinceRes.data.province_id || provinceRes.data.id || provinceRes.data.pro_id;
        }
      } catch (e) {
        console.log("Could not find province for org:", item.to_org_code);
      }
    }

    // 5. Set all form values
    form.setFieldsValue({
      user_id: item.user_id,
      province_id: foundProvinceId || undefined,
      to_org_code: item.to_org_code,
      to_department: item.to_department || undefined,
      to_position: item.to_position || undefined,
      effective_date: item.effective_date ? dayjs(item.effective_date) : null,
      transfer_type: item.transfer_type || 'internal',
      reason: item.reason || '',
    });

    // 6. Load cascading data sequentially
    if (foundProvinceId) {
      setSelectedProvince(foundProvinceId);
      await loadOrganizations(foundProvinceId);
    }
    
    setSelectedOrg(item.to_org_code);
    if (item.to_org_code) {
      await loadDepartments(item.to_org_code);
      if (item.to_department) {
        await loadPositions(item.to_department);
      }
    }

    setIsModalVisible(true);
  } catch (error) {
    console.log("Error opening edit modal:", error);
    message.error("មិនអាចបើកទម្រង់កែប្រែបានទេ");
  } finally {
    setLoadingModalOpen(false); // បញ្ចប់ loading modal
  }
};
  // ==================== CASCADING HANDLERS ====================
  const handleProvinceChange = async (provinceId) => {
    setSelectedProvince(provinceId);
    form.setFieldsValue({ to_org_code: undefined, to_department: undefined, to_position: undefined });
    setOrganizations([]);
    setDepartments([]);
    setPositions([]);
    setSelectedOrg(null);
    await loadOrganizations(provinceId);
  };

  const handleOrgChange = async (orgCode) => {
    setSelectedOrg(orgCode);
    form.setFieldsValue({ to_department: undefined, to_position: undefined });
    setDepartments([]);
    setPositions([]);
    await loadDepartments(orgCode);
  };

  const handleDepartmentChange = async (departmentCode) => {
    form.setFieldsValue({ to_position: undefined });
    setPositions([]);
    await loadPositions(departmentCode);
  };
// នៅខាងដើម component បន្ទាប់ពី getProfile
useEffect(() => {
  console.log("Current User Profile:", getProfile);
  console.log("Current User org_code:", getProfile.org_code);
  console.log("Current User org_code type:", typeof getProfile.org_code);
}, []);
  // ==================== SUBMIT ====================
  const handleModalSubmit = async () => {
    try {
      const values = await form.validateFields();

      const submitData = {
        user_id: values.user_id,
        to_org_code: values.to_org_code,
        to_department: values.to_department || null,
        to_position: values.to_position || null,
        effective_date: values.effective_date ? values.effective_date.format('YYYY-MM-DD') : null,
        transfer_type: values.transfer_type || 'internal',
        reason: values.reason || '',
      };

      console.log("Submitting data:", submitData);

      setLoadingSpin(true);

      let res;
      if (editingId) {
        res = await request("employee/history", "PUT", { ...submitData, id: editingId });
      } else {
        res = await request("employee/history", "POST", submitData);
      }

      if (res && res.success) {
        message.success(editingId ? "កែប្រែបានជោគជ័យ" : "ផ្ទេរបុគ្គលិកបានជោគជ័យ");
        setIsModalVisible(false);
        form.resetFields();
        getList();
      } else {
        throw new Error(res?.message || "មានបញ្ហាក្នុងការរក្សាទុក");
      }
    } catch (error) {
      console.log("Submit error:", error);
      message.error(error.message || "មានបញ្ហាក្នុងការរក្សាទុក");
    } finally {
      setLoadingSpin(false);
    }
  };

  // ==================== CANCEL ====================
  const handleModalCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
    setEditingId(null);
    setSelectedProvince(null);
    setSelectedOrg(null);
    setOrganizations([]);
    setDepartments([]);
    setPositions([]);
  };
// ==================== APPROVE ====================
const handleApprove = (item) => {
  setApproveItem(item);
  setApproveWord("");
  approveForm.resetFields();
  setIsApproveModalVisible(true);
};

const handleApproveSubmit = async () => {
  try {
    const values = await approveForm.validateFields();
    
    if (values.confirmWord !== "Approval") {
      message.error("សូមបញ្ចូលពាក្យ 'Approval' ឱ្យបានត្រឹមត្រូវ");
      return;
    }

    setLoadingSpin(true);
    
    // ប្រើ API ថ្មីសម្រាប់ approval
    const res = await request("employee/approvalmovement", "PUT", {
      id: approveItem.id,
    });

    if (res && res.success) {
      message.success("បានអនុម័តដោយជោគជ័យ");
      setIsApproveModalVisible(false);
      getList();
    } else {
      throw new Error(res?.message || "មានបញ្ហាក្នុងការអនុម័ត");
    }
  } catch (error) {
    console.log("Approve error:", error);
    message.error(error.message || "មានបញ្ហាក្នុងការអនុម័ត");
  } finally {
    setLoadingSpin(false);
  }
};
  // ==================== RENDER SELECT OPTION ====================
  const renderSelectOption = (staff) => {
    const imageUrl = getImageUrl(staff.image);
    return (
      <Space>
        <Avatar
          src={imageUrl}
          icon={!imageUrl && <UserOutlined />}
          size="medium"
        />
        <div>
          <div>{staff.name} | {staff.position}</div>
        </div>
      </Space>
    );
  };

  // ==================== TABLE COLUMNS ====================
  const columns = [
    {
      key: "id",
      title: "ល.រ",
      dataIndex: "id",
      width: 70,
    },
    {
      key: "staff",
      title: "បុគ្គលិក",
      render: (_, record) => {
        const imageUrl = getImageUrl(record.image);
        console.log('image by url',imageUrl)
        return (
          <Space>
           <div style={{ position: "relative", display: "inline-block" }}>
  <Avatar
    src={imageUrl}
    icon={!imageUrl && <UserOutlined />}
    style={{
      width: 45,
      height: 45,
      border: '2px solid #208606ff',
    }}
  />
  {/* Dot ស្ថានភាព */}
  <span style={{
    position: "absolute",
    bottom: "2px",
    right: "2px",
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    background:   "#52c41a"  ,
    border: "2px solid #fff",
    boxShadow: "0 0 4px rgba(0,0,0,0.2)",
  }} />
</div>
            <div>
              <div><strong>{record.fullname || "-"}</strong></div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                {record.username || "-"}
              </div>
            </div>
          </Space>
        );
      },
    },
    {
      key: "movement",
      title: "ការផ្លាស់ប្តូរ",
      render: (_, record) => (
        <div>
          <div style={{ fontSize: '13px' }}>
            <Tag color="red">{record.from_org_name || "-"}</Tag>
            <SwapOutlined style={{ margin: '0 8px', color: '#1890ff' }} />
            <Tag color="green">{record.to_org_name || "-"}</Tag>
          </div>
          <div style={{ fontSize: '12px', color: '#666', marginTop: 4 }}>
            {record.from_department_name || "-"} → {record.to_department_name || "-"}
          </div>
          <div style={{ fontSize: '12px', color: '#666' }}>
            {record.from_position_name || "-"} → {record.to_position_name || "-"}
          </div>
        </div>
      ),
    },
    {
      key: "transfer_type",
      title: "ប្រភេទផ្ទេរ",
      dataIndex: "transfer_type",
      width: 130,
      render: (value) => {
        const typeMap = {
          internal: { color: 'blue', text: 'ផ្ទៃក្នុង' },
          external: { color: 'orange', text: 'ខាងក្រៅ' },
          temporary: { color: 'purple', text: 'បណ្តោះអាសន្ន' },
        };
        const type = typeMap[value] || { color: 'default', text: value };
        return <Tag color={type.color}>{type.text}</Tag>;
      },
    },
    {
      key: "effective_date",
      title: "កាលបរិច្ឆេទ",
      dataIndex: "effective_date",
      width: 130,
      render: (value) => formateDateSystem(value),
    },
    {
      key: "status",
      title: "ស្ថានភាព",
      dataIndex: "status",
      width: 120,
      render: (value) => {
        const statusMap = {
          pending: { color: 'gold', text: 'កំពុងរង់ចាំ' },
          approved: { color: 'green', text: 'បានអនុម័ត' },
          completed: { color: 'blue', text: 'បានបញ្ចប់' },
          cancelled: { color: 'red', text: 'បានបោះបង់' },
        };
        const status = statusMap[value] || { color: 'default', text: value };
        return <Tag color={status.color}>{status.text}</Tag>;
      },
    },
    {
      key: "reason",
      title: "មូលហេតុ",
      dataIndex: "reason",
      ellipsis: true,
      width: 150,
    },
  {
  key: "action",
  title: "សកម្មភាព",
  width: 220,
  render: (_, item) => {
    const isPending = item.status === 'pending';
    const isApproved = item.status === 'approved';
    
    // ប្រៀបធៀបជា string ឬ number
    const currentUserOrg = String(getProfile.org_code);
    const itemFromOrg = String(item.from_org_code);
    const itemToOrg = String(item.to_org_code);
    
    console.log("Action check:", { currentUserOrg, itemFromOrg, itemToOrg });
    
    const isTargetOrg = itemToOrg === currentUserOrg;
    const isSourceOrg = itemFromOrg === currentUserOrg;
    
    const canApprove = isPending && isTargetOrg;
    const canEdit = isPending && isSourceOrg;
    const canDelete = isPending && isSourceOrg;

    return (
      <Space>
        {canEdit && (
          <Button
            icon={<EditFilled />}
            type="primary"
            onClick={() => handleEdit(item)}
            size="small"
            loading={loadingModalOpen && editingId === item.id}
            title="កែប្រែ"
          />
        )}

        {canApprove && (
          <Button
            icon={<CheckCircleOutlined />}
            type="primary"
            style={{ background: '#52c41a', borderColor: '#52c41a' }}
            onClick={() => handleApprove(item)}
            size="small"
            title="អនុម័ត"
          />
        )}

        {isApproved && (
          <Tag color="success" style={{ marginRight: 0 }}>
            <CheckCircleOutlined /> បានអនុម័ត
          </Tag>
        )}
   
         {canDelete && (
            <Popconfirm
            placement="leftTop"
            title="លុប"
            description="តើអ្នកប្រាកដថាចង់លុបទេ?"
            okText="យល់ព្រម"
            cancelText="បោះបង់"
            onConfirm={() => handleDelete(item)}
          >
            <Button danger type="primary" icon={<CloseOutlined />} loading={loadingSpin} size="small" title="លុប" />
          </Popconfirm>
        
         )}
        
      </Space>
    );
  },
},
  ];

  // ==================== RENDER ====================
  return (
    <div>
      {loadingSpin && (
        <div className="sprinSave">
          <GetLoading />
        </div>
      )}

      <div style={boxHeader}>
        <div style={{ display: "flex", alignItems: "center", gap: "16px", width: "100%" }}>
          <Space>
            {boxHeaderTagText("ប្រវត្តិការផ្លាស់ប្តូរអង្គភាពបុគ្គលិក")}
          </Space>
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", gap: "12px" }}>
            <Input
              placeholder="ស្វែងរកតាមឈ្មោះ ឬអង្គភាព..."
              prefix={<SearchOutlined />}
              value={txtSearch}
              onChange={(e) => handleSearch(e.target.value)}
              allowClear
              style={{ width: 250 }}
            />
            <Select
              value={filterParam.status}
              onChange={handleStatusFilter}
              style={{ width: 150 }}
              placeholder="ស្ថានភាព"
            >
              <Option value="all">ទាំងអស់</Option>
              <Option value="pending">កំពុងរង់ចាំ</Option>
              <Option value="approved">បានអនុម័ត</Option>
              <Option value="completed">បានបញ្ចប់</Option>
              <Option value="cancelled">បានបោះបង់</Option>
            </Select>
         <Button
            className="buttonstylekhmer"
            type="primary"
            icon={<PlusCircleOutlined />}
            onClick={handleAddNew}
            loading={loadingModalOpen && editingId === null} // បង្ហាញ loading លើ button ពេលកំពុងបើក modal add
            >
            ផ្ទេរបុគ្គលិក
            </Button>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div className="sprinCustome">
            <GetLoading />
          </div>
        ) : (
          <Table
            pagination={{ pageSize: 10, showTotal: (total) => `សរុប ${total}` }}
            columns={columns}
            size="small"
            dataSource={list}
            rowKey="id"
            scroll={{ x: 1100 }}
          />
        )}
      </div>

      {/* ==================== MODAL ==================== */}
      <Modal
        title={
          <div style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'Content' }}>
            <Space>
              <SwapOutlined style={{ color: '#1890ff' }} />
              {editingId ? "កែប្រែការផ្ទេរបុគ្គលិក" : "ផ្ទេរបុគ្គលិកទៅអង្គភាពថ្មី"}
            </Space>
          </div>
        }
        open={isModalVisible}
        onOk={handleModalSubmit}
        onCancel={handleModalCancel}
        width={900}
        okText={editingId ? "រក្សាទុក" : "ផ្ទេរ"}
        cancelText="បោះបង់"
        confirmLoading={loadingSpin}
      >
        <Spin spinning={loadingModalOpen} tip="កំពុងផ្ទុក...">
          <Form form={form} layout="vertical" style={{ marginTop: 20 }}>
            <div style={{ display: 'flex', gap: '24px' }}>

              {/* ========== LEFT COLUMN ========== */}
              <div style={{ flex: 1, borderRight: '1px solid #f0f0f0', paddingRight: '24px' }}>
                <div style={{
                  fontSize: '14px', fontWeight: 'bold', color: '#1890ff',
                  marginBottom: '16px', borderBottom: '2px solid #1890ff',
                  paddingBottom: '8px', fontFamily: 'Content'
                }}>
                  <Space><BankOutlined />ព័ត៌មានអង្គភាពថ្មី</Space>
                </div>

                {/* Staff Selection */}
                <Form.Item
                  name="user_id"
                  label={<Space><UserOutlined />ជ្រើសរើសបុគ្គលិក</Space>}
                  rules={[{ required: true, message: "សូមជ្រើសរើសបុគ្គលិក" }]}
                >
                  <Select
                    placeholder="ស្វែងរកបុគ្គលិក..."
                    showSearch
                    size="large"
                    loading={loadingStaff}
                    disabled={editingId !== null}
                    notFoundContent={loadingStaff ? <Spin size="small" /> : "មិនមានទិន្នន័យ"}
                    onSearch={(inputValue) => handleStaffSearch(inputValue, objFilterStaff)}
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {staffList.map((staff) => (
                      <Option key={staff.user_id} value={staff.user_id} label={staff.label}>
                        {renderSelectOption(staff)}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                {/* Province */}
                <Form.Item
                  name="province_id"
                  label={<Space><EnvironmentOutlined />ខេត្ត (អង្គភាពថ្មី)</Space>}
                  rules={[{ required: true, message: "សូមជ្រើសរើសខេត្ត" }]}
                >
                  <Select
                    placeholder="ជ្រើសរើសខេត្ត"
                    showSearch
                    size="large"
                    loading={loadingProvinces}
                    onChange={handleProvinceChange}
                    optionFilterProp="children"
                    notFoundContent={loadingProvinces ? <Spin size="small" /> : "មិនមានទិន្នន័យ"}
                  >
                    {provinces.map((p) => (
                      <Option key={p.id} value={p.id}>{p.province_name_khmer}</Option>
                    ))}
                  </Select>
                </Form.Item>

                {/* Organization */}
                <Form.Item
                  name="to_org_code"
                  label={<Space><BankOutlined />អង្គភាពថ្មី</Space>}
                  rules={[{ required: true, message: "សូមជ្រើសរើសអង្គភាព" }]}
                >
                  <Select
                    placeholder={selectedProvince ? "ជ្រើសរើសអង្គភាព" : "សូមជ្រើសរើសខេត្តសិន"}
                    showSearch
                    size="large"
                    loading={loadingOrganizations}
                    onChange={handleOrgChange}
                    optionFilterProp="children"
                    disabled={!selectedProvince}
                    notFoundContent={loadingOrganizations ? <Spin size="small" /> : "មិនមានទិន្នន័យ"}
                  >
                    {organizations.map((org) => (
                      <Option key={org.org_code} value={org.org_code}>{org.org_name_kh}</Option>
                    ))}
                  </Select>
                </Form.Item>

                {/* Department */}
                <Form.Item name="to_department" label={<Space><ApartmentOutlined />ដេប៉ាតឺម៉ង់ថ្មី</Space>}>
                  <Select
                    placeholder="ជ្រើសរើសដេប៉ាតឺម៉ង់ (ស្រេចចិត្ត)"
                    showSearch
                    size="large"
                    loading={loadingDepartments}
                    onChange={handleDepartmentChange}
                    optionFilterProp="children"
                    allowClear
                    notFoundContent={loadingDepartments ? <Spin size="small" /> : "មិនមានទិន្នន័យ"}
                  >
                    {departments.map((dept) => (
                      <Option key={dept.code} value={dept.code}>{dept.department_name}</Option>
                    ))}
                  </Select>
                </Form.Item>

                {/* Position */}
                <Form.Item name="to_position" label={<Space><IdcardOutlined />តំណែងថ្មី</Space>}>
                  <Select
                    placeholder="ជ្រើសរើសតំណែង (ស្រេចចិត្ត)"
                    showSearch
                    size="large"
                    loading={loadingPositions}
                    optionFilterProp="children"
                    allowClear
                    notFoundContent={loadingPositions ? <Spin size="small" /> : "មិនមានទិន្នន័យ"}
                  >
                    {positions.map((pos) => (
                      <Option key={pos.id} value={pos.id}>{pos.position_kh}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              {/* ========== RIGHT COLUMN ========== */}
              <div style={{ flex: 1, paddingLeft: '24px' }}>
                <div style={{
                  fontSize: '14px', fontWeight: 'bold', color: '#52c41a',
                  marginBottom: '16px', borderBottom: '2px solid #52c41a',
                  paddingBottom: '8px', fontFamily: 'Content'
                }}>
                  <Space><SwapOutlined />ព័ត៌មានផ្ទេរ</Space>
                </div>

                {/* Transfer Type */}
                <Form.Item
                  name="transfer_type"
                  label={<Space><SwapOutlined />ប្រភេទផ្ទេរ</Space>}
                  rules={[{ required: true, message: "សូមជ្រើសរើសប្រភេទផ្ទេរ" }]}
                >
                  <Select size="large" placeholder="ជ្រើសរើសប្រភេទផ្ទេរ">
                    <Option value="internal"><Space><Tag color="blue">ផ្ទៃក្នុង</Tag>ផ្ទេរផ្ទៃក្នុង</Space></Option>
                    <Option value="external"><Space><Tag color="orange">ខាងក្រៅ</Tag>ផ្ទេរខាងក្រៅ</Space></Option>
                    <Option value="temporary"><Space><Tag color="purple">បណ្តោះអាសន្ន</Tag>ផ្ទេរបណ្តោះអាសន្ន</Space></Option>
                  </Select>
                </Form.Item>

                {/* Effective Date */}
                <Form.Item
                  name="effective_date"
                  label={<Space><CalendarOutlined />កាលបរិច្ឆេទមានប្រសិទ្ធភាព</Space>}
                  rules={[{ required: true, message: "សូមជ្រើសរើសកាលបរិច្ឆេទ" }]}
                >
                  <DatePicker style={{ width: "100%" }} size="large" format="YYYY-MM-DD" placeholder="ជ្រើសរើសកាលបរិច្ឆេទ" />
                </Form.Item>

                {/* Reason */}
                <Form.Item name="reason" label={<Space><FileTextOutlined />មូលហេតុ</Space>}>
                  <Input.TextArea rows={5} placeholder="បញ្ចូលមូលហេតុនៃការផ្ទេរ..." size="large" />
                </Form.Item>

                {/* Info Box */}
                <div style={{
                  background: '#e6f7ff', border: '1px solid #91d5ff',
                  borderRadius: '8px', padding: '12px 16px', marginTop: '16px', fontFamily: 'Content'
                }}>
                  <div style={{ fontSize: '13px', color: '#1890ff', fontWeight: 'bold', marginBottom: '8px' }}>
                    <Space><InfoCircleOutlined />កំណត់ចំណាំ</Space>
                  </div>
                  <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', color: '#666', lineHeight: '1.8' }}>
                    <li><Tag color="blue">ផ្ទៃក្នុង</Tag>ផ្ទេរជាអចិន្ត្រៃយ៍ទៅអង្គភាពថ្មី</li>
                    <li><Tag color="purple">បណ្តោះអាសន្ន</Tag>ផ្ទេរបណ្តោះអាសន្ន នៅតែគោរពច្បាប់អង្គភាពដើម</li>
                    <li><Tag color="orange">ខាងក្រៅ</Tag>ផ្ទេរទៅអង្គភាពក្រៅប្រព័ន្ធ</li>
                  </ul>
                </div>
              </div>
            </div>
          </Form>
        </Spin>
      </Modal>
      {/* ==================== APPROVE MODAL ==================== */}
<Modal
  title={
    <div style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'Content' }}>
      <Space>
        <CheckCircleOutlined style={{ color: '#52c41a' }} />
        បញ្ជាក់ការអនុម័ត
      </Space>
    </div>
  }
  open={isApproveModalVisible}
  onOk={handleApproveSubmit}
  onCancel={() => setIsApproveModalVisible(false)}
  width={500}
  okText="អនុម័ត"
  cancelText="បោះបង់"
  confirmLoading={loadingSpin}
  okButtonProps={{ style: { background: '#52c41a', borderColor: '#52c41a' } }}
>
  <div style={{ padding: '20px 0' }}>
    <div style={{ 
      background: '#fffbe6', 
      border: '1px solid #ffe58f', 
      borderRadius: '8px', 
      padding: '16px',
      marginBottom: '20px'
    }}>
      <Space>
        <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: '16px' }} />
        <span style={{ fontSize: '14px' }}>
          សូមវាយពាក្យ <strong>"Approval"</strong> ដើម្បីបញ្ជាក់ការអនុម័ត
        </span>
      </Space>
    </div>

    {approveItem && (
      <div style={{ marginBottom: '20px', padding: '12px', background: '#fafafa', borderRadius: '8px' }}>
        <div><strong>បុគ្គលិក៖</strong> {approveItem.fullname}</div>
        <div><strong>ពី៖</strong> {approveItem.from_org_name} → <strong>ទៅ៖</strong> {approveItem.to_org_name}</div>
        <div><strong>កាលបរិច្ឆេទ៖</strong> {formateDateSystem(approveItem.effective_date)}</div>
      </div>
    )}

    <Form form={approveForm} layout="vertical">
      <Form.Item
        name="confirmWord"
        label="វាយពាក្យ 'Approval' ដើម្បីបញ្ជាក់"
        rules={[
          { required: true, message: "សូមបញ្ចូលពាក្យ 'Approval'" },
          {
            validator: (_, value) => {
              if (value === "Approval") {
                return Promise.resolve();
              }
              return Promise.reject(new Error("សូមបញ្ចូលពាក្យ 'Approval' ឱ្យបានត្រឹមត្រូវ"));
            },
          },
        ]}
      >
        <Input 
          placeholder="Approval" 
          size="large"
          style={{ fontFamily: 'monospace', letterSpacing: '2px' }}
        />
      </Form.Item>
    </Form>
  </div>
</Modal>
    </div>
  );
};

export default EmpHistoryMovement;